export default "__VITE_ASSET__vcmQN6qh__"